import { escaparHtml } from '@/utils/escapar-html';

/**
 * Makes the "Produtos, Loterias e Serviços" options (GET used by /metas and
 * /dashboard-lotericas, built by MovvendasTable::getListaProdutosSelect) safe to render as
 * HTML, so the selects can keep Vue 2's look with `options-html` / `display-value-html`.
 *
 * Quasar 1 rendered every QSelect label as innerHTML unless told to sanitize; Quasar 2
 * renders text unless told otherwise. The API puts markup in one kind of option only, the
 * group header (`<span style="color: #3366cc; font-weight: bold;">Loterias - Todos</span>`),
 * which Quasar 2 showed as raw tags. Product names are user data and were innerHTML on
 * Vue 2 as well. Here every label is escaped; the header's text is escaped and re-wrapped
 * in a fixed style (the style attribute coming from the API is not reused).
 */
const CABECALHO = /^\s*<span\b[^>]*>([\s\S]*)<\/span>\s*$/i;
const ESTILO_CABECALHO = 'color: #3366cc; font-weight: bold;';

export function opcoesProdutosSeguras(opcoes) {
  if (!Array.isArray(opcoes)) return opcoes;
  return opcoes.map(opcao => {
    if (!opcao || typeof opcao.label !== 'string') return opcao;
    const cabecalho = opcao.label.match(CABECALHO);
    const label = cabecalho
      ? `<span style="${ESTILO_CABECALHO}">${escaparHtml(cabecalho[1].replace(/<[^>]*>/g, ''))}</span>`
      : escaparHtml(opcao.label);
    return { ...opcao, label };
  });
}
